<template>
  <div>
    <Head title="Woodwork WIP Returns" />
    <h1 class="mb-8 text-3xl font-bold">Woodwork WIP Returns</h1>
    <div class="bg-white rounded-md shadow mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pr-8 pl-8 pb-8">
          <div class="pb-2 pr-6 w-full lg:w-1/2">
            <multiselect
              id="location_id"
              v-model="selectedLocation"
              placeholder="Search Locations"
              :options="locations" 
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.location_id"
              :style="form.errors.location_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchLocationChange"
              @input="onSelectedLocation"
            />
            <div v-if="form.errors.location_id" class="form-error">{{ form.errors.location_id }}</div>
          </div>
          <div class="pb-2 pr-6 w-full lg:w-1/2">
            <text-input
              v-model="form.item_id"
              :error="form.errors.item_id"
              placeholder="Scan UID"
            />
          </div>
        </div>
          <div
            class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
          >
            <loading-button
              :loading="form.processing"
              class="btn-orange px-3 py-2 text-xs"
              type="submit"
            >
              Add Return
            </loading-button>
          </div>
      </form>
    </div>
    <hr/>
    <ul class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4" id="tabs-tabFill"
      role="tablist">
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-homeFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active
        " id="tabs-home-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true">Today's Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-profileFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-profile-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false">All Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a href="#tabs-summaryFill" class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
        " id="tabs-summary-tabFill" data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false">Summaries</a>
      </li>
    </ul>
    <div class="tab-content" id="tabs-tabContentFill">
      <div class="tab-pane fade show active" id="tabs-homeFill" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Team</th>
              <th class="pb-2 pt-2 px-3">Item UID</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
              <th class="pb-2 pt-2 px-3">User</th>
            </tr>
            <tr v-for="item in today_sofas.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.issuance_team }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.part_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.unit_of_measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ item.user }}
                </Link>
              </td>
            </tr>
            <tr v-if="today_sofas.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="today_sofas.links" />
      </div>
      <div class="tab-pane fade" id="tabs-profileFill" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3"  @reset="reset"/>
          <a
            v-if="sofas.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/wip/returns/woodwork/download?dateValue=${search.dateValue}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Date</th>
              <th class="pb-2 pt-2 px-3">Team</th>
              <th class="pb-2 pt-2 px-3">Item UID</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
              <th class="pb-2 pt-2 px-3">User</th>
            </tr>
            <tr v-for="sofa in sofas.data" :key="sofa.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3 focus:text-orange-500">
                  {{ sofa.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.issuance_team }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.part_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.unit_of_measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ sofa.user }}
                </Link>
              </td>
            </tr>
            <tr v-if="sofas.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="12">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="sofas.links" />
      </div>
      <div class="tab-pane fade" id="tabs-summaryFill" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="summari.dateRange" class="mr-0 w-full max-w-md mr-3"  @reset="resets"/>
          <a
            v-if="summaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/wip/returns/woodwork/summaries/download?dateRange=${summari.dateRange}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Team</th>
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Description</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
            </tr>
            <tr v-for="summary in summaries.data" :key="summary.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.issuance_team }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.part_number }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.unit_of_measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-3" tabindex="-1">
                  {{ summary.location }}
                </Link>
              </td>
            </tr>
            <tr v-if="summaries.data.length === 0">
              <td class="px-3 py-3 border-t" colspan="12">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="summaries.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import DateRange from '@/Shared/DateRange'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    //Icon,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    today_sofas: Object,
    sofas: Object,
    summaries: Object,
    locations: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        item_id: null,
        quantity: null,
        location_id: null,
        team: 'woodwork',
      }),
      search: {
        dateValue: this.filters.dateValue
      },
      summari: {
        dateRange: this.filters.dateRange
      },
      selectedLocation: null,
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/wip-returns/woodwork', pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summari: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/wip-returns/woodwork', pickBy(this.summari), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    resets() {
      this.summari = mapValues(this.summari, () => null)
    },
    store() {
      this.form.post('/wip-returns/woodwork', {
        onSuccess: () => {
          this.form.reset(
            'item_id',
          )
        },
      });
    },
    onSelectedLocation(location, id) {
      this.form.location_id = location
      this.selectedLocation = location
    },
    onSearchLocationChange: throttle(function (location) {
    }, 200),
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
